module.exports = __webpack_public_path__ + "img/xbCode.b43278cf.jpg";